import { CircularProgress, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingIndicator = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  if (isMobile) {
    return (
      <Wrapper>
        <CircularProgress size={16} thickness={5} />
      </Wrapper>
    );
  }

  if (isTablet) {
    return (
      <Wrapper>
        <CircularProgress size={18} thickness={5} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <CircularProgress size={20} thickness={5} />
    </Wrapper>
  );
};

export default LoadingIndicator;
